import { Component, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 's5-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements AfterViewInit {

  iframe: boolean = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.isInsideIframe()) {
        this.iframe = true;
      }
    });
  }

  isInsideIframe(): boolean {
    try {
      // Check if the current window is not the top-most window
      return window.self !== window.top;
    } catch (e) {
      // In case of a cross-origin scenario where accessing window.top
      // throws an error, we can safely assume it's an iframe.
      return true;
    }
  }

}
